import { Headers } from 'cross-fetch';
import { v4 } from 'uuid';
// https://stash/projects/COM/repos/mono-java/browse/common-client/src/main/java/com/cvent/filters/AuditConstants.java
const HTTP_REQUEST_ID = 'HttpLogRequestId';
const HTTP_PAGE_ID = 'HttpLogPageLoadId';
let _httpLogPageLoadId;
/**
 *
 *   Fetch RequestMiddleware to add HttpLogPageLoadId and HttpLogRequestId headers (new or from provided source)
 *   If not already set. HttpLogPageLoadId won't only in a browser environment.
 */
export function withTraces(options) {
    if (!_httpLogPageLoadId) {
        _httpLogPageLoadId = v4();
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    return async (url, init) => {
        // IncomingMessage headers are made into lower case by node.js
        const requestId = options?.source?.headers?.[HTTP_REQUEST_ID.toLowerCase()] || v4();
        const headers = new Headers(init?.headers);
        if (!headers.has(HTTP_REQUEST_ID)) {
            headers.set(HTTP_REQUEST_ID, requestId);
        }
        if (!headers.has(HTTP_PAGE_ID) && typeof window !== 'undefined') {
            // allow user code to provide their own pageload id if they want,
            // on a browser default to the one created when this middleware is first executed
            const pageLoadId = options?.source?.headers?.[HTTP_PAGE_ID] || _httpLogPageLoadId;
            headers.set(HTTP_PAGE_ID, pageLoadId);
        }
        return [url, { ...init, headers }];
    };
}
//# sourceMappingURL=withTraces.js.map